import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { Col, FormControl, Row } from 'react-bootstrap';
import { connect as connectR } from 'react-redux';
import translate from '../../translate';
import ValidatorFormGroup from '../../main/validator-form-group';
import { getCountryName } from '../../../util/country-display';

const PROPAGATE_MANSION_ADDRESS_CHANGES =
    'propagate_mansion_address_to_all_locations';
const VALIDATORS = {
    street: {
        isValid: (value) =>
            `${value}`.replace(/\s/, '').length >= 3 && value.length < 63,
    },
    housenumber: {
        isValid: (value) =>
            `${value}`.replace(/\s/, '').length >= 1 && value.length < 15,
    },
    description: { isValid: () => true },
    postalcode: {
        isValid: (value, country_id) =>
            country_id !== 1 || /^\s*\d{5}$/.test(value),
    },
    city: { isValid: (value) => `${value}`.replace(/\s/, '').length >= 3 },
};

const ObjectAddressForm = createReactClass({
    displayName: 'ObjectAddressForm',

    propTypes: {
        address: PropTypes.shape({
            street: PropTypes.string,
            housenumber: PropTypes.string,
            city: PropTypes.string,
            description: PropTypes.string,
            postalcode: PropTypes.string,
            country_id: PropTypes.number,
        }),
        handleChange: PropTypes.func.isRequired,
        forceValidation: PropTypes.bool,
        showPropagateGpsLocationCheckbox: PropTypes.bool,
        disabled: PropTypes.bool,
        strings: PropTypes.object,
        countries: PropTypes.shape({}).isRequired,
        selectedPartner: PropTypes.shape({}).isRequired,
    },
    defaultProps: {
        disabled: false,
        forceValidation: false,
        showPropagateGpsLocationCheckbox: false,
        strings: {
            street: 'Straße',
            city: 'Ort',
            description: 'Adresszusatz',
            postalcode: 'Postleitzahl',
            country_id: 'Land',
            housenumber: 'Hausnummer',
        },
    },
    getInitialState() {
        return _.extend(
            {
                street: '',
                housenumber: '',
                city: '',
                description: '',
                postalcode: '',
                updateAllLocations: true,
                _dirty: {},
                _valid: false,
            },
            this.props.address
        );
    },

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            this.setState(nextProps.address, this._persistState);
        }
    },

    _persistState() {
        const new_state = {};
        _.each(
            [
                'street',
                'housenumber',
                'city',
                'description',
                'postalcode',
                'updateAllLocations',
            ],
            (fieldName) => {
                new_state[fieldName] = this.state[fieldName];
            }
        );
        // return valid state to parent
        new_state._valid = Object.keys(VALIDATORS).reduce(
            (formValid, fieldName) =>
                formValid &&
                VALIDATORS[fieldName].isValid(new_state[fieldName]),
            true
        );
        const selectedPartner = this.props.selectedPartner;
        new_state.country_id = selectedPartner && selectedPartner.country_id;
        new_state._valid =
            new_state._valid &&
            VALIDATORS.postalcode.isValid(
                new_state.postalcode,
                new_state.country_id
            );
        this.props.handleChange(new_state);
    },

    _markDirty(key) {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    },

    _handleFieldChange(key, value) {
        this._markDirty(key);
        const newSt = _.set({}, key, value);
        newSt[key] = value;
        this.setState(newSt, this._persistState);
    },

    renderPropagateHtmlCheckbox() {
        if (
            this.props.showPropagateGpsLocationCheckbox &&
            !this.props.disabled
        ) {
            return (
                <div className="checkbox checkbox-primary checkbox-custom">
                    <input
                        type="checkbox"
                        id={PROPAGATE_MANSION_ADDRESS_CHANGES}
                        name={PROPAGATE_MANSION_ADDRESS_CHANGES}
                        checked={this.state.updateAllLocations}
                        className="styled"
                        disabled={this.props.disabled}
                        onChange={() => {
                            this.setState(
                                {
                                    updateAllLocations:
                                        !this.state.updateAllLocations,
                                },
                                this._persistState
                            );
                        }}
                    />
                    <label htmlFor={PROPAGATE_MANSION_ADDRESS_CHANGES}>
                        {this.props.strings.propagateChangesToLocations}
                    </label>
                </div>
            );
        } else {
            return <div />;
        }
    },

    render() {
        const selectedPartner = this.props.selectedPartner;
        const accountingAreaCountryId =
            selectedPartner && selectedPartner.country_id;

        const countries = [this.props.countries[accountingAreaCountryId]];
        if (countries) {
            return (
                <div>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <ValidatorFormGroup
                                label={this.props.strings.street}
                                hideErrorLabel={
                                    !(
                                        this.state._dirty.street ||
                                        this.props.forceValidation
                                    ) ||
                                    VALIDATORS.street.isValid(this.state.street)
                                }
                                errorLabel={this.props.strings.streetError}
                            >
                                <FormControl
                                    type="text"
                                    className={`input-text-color`}
                                    value={this.state.street}
                                    name="street"
                                    data-testid="street-input"
                                    onChange={(event) => {
                                        this._handleFieldChange(
                                            'street',
                                            event.target.value
                                        );
                                    }}
                                    required
                                    disabled={this.props.disabled}
                                />
                            </ValidatorFormGroup>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <ValidatorFormGroup
                                label={this.props.strings.housenumber}
                                hideErrorLabel={
                                    !(
                                        this.state._dirty.housenumber ||
                                        this.props.forceValidation
                                    ) ||
                                    VALIDATORS.housenumber.isValid(
                                        this.state.housenumber
                                    )
                                }
                                errorLabel={this.props.strings.housenumberError}
                            >
                                <FormControl
                                    type="text"
                                    className={`input-text-color`}
                                    value={this.state.housenumber}
                                    name="housenumber"
                                    data-testid="house-number-input"
                                    onChange={(event) => {
                                        this._handleFieldChange(
                                            'housenumber',
                                            event.target.value
                                        );
                                    }}
                                    required
                                    disabled={this.props.disabled}
                                />
                            </ValidatorFormGroup>
                        </Col>
                    </Row>

                    <ValidatorFormGroup
                        label={this.props.strings.description}
                        hideErrorLabel={
                            !(
                                this.state._dirty.description ||
                                this.props.forceValidation
                            ) ||
                            VALIDATORS.description.isValid(
                                this.state.description
                            )
                        }
                        errorLabel={this.props.strings.descriptionError}
                    >
                        <FormControl
                            type="text"
                            className={`input-text-color`}
                            value={this.state.description}
                            name="description"
                            data-testid="description-input"
                            onChange={(event) => {
                                this._handleFieldChange(
                                    'description',
                                    event.target.value
                                );
                            }}
                            disabled={this.props.disabled}
                        />
                    </ValidatorFormGroup>
                    <Row>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <ValidatorFormGroup
                                label={this.props.strings.postalcode}
                                hideErrorLabel={
                                    !(
                                        this.state._dirty.postalcode ||
                                        this.props.forceValidation
                                    ) ||
                                    VALIDATORS.postalcode.isValid(
                                        this.state.postalcode,
                                        accountingAreaCountryId
                                    )
                                }
                                errorLabel={this.props.strings.postalcodeError}
                            >
                                <FormControl
                                    type="text"
                                    className={`input-text-color`}
                                    value={this.state.postalcode}
                                    name="postalcode"
                                    data-testid="postcode-input"
                                    onChange={(event) => {
                                        this._handleFieldChange(
                                            'postalcode',
                                            event.target.value
                                        );
                                    }}
                                    required
                                    disabled={this.props.disabled}
                                />
                            </ValidatorFormGroup>
                        </Col>

                        <Col xs={8} sm={8} md={8} lg={8}>
                            <ValidatorFormGroup
                                label={this.props.strings.city}
                                hideErrorLabel={
                                    !(
                                        this.state._dirty.city ||
                                        this.props.forceValidation
                                    ) ||
                                    VALIDATORS.city.isValid(this.state.city)
                                }
                                errorLabel={this.props.strings.cityError}
                            >
                                <FormControl
                                    type="text"
                                    className={`input-text-color`}
                                    value={this.state.city}
                                    name="city"
                                    data-testid="city-input"
                                    onChange={(event) => {
                                        this._handleFieldChange(
                                            'city',
                                            event.target.value
                                        );
                                    }}
                                    required
                                    disabled={this.props.disabled}
                                />
                            </ValidatorFormGroup>
                        </Col>
                    </Row>
                    <ValidatorFormGroup
                        label={this.props.strings.country_id}
                        hideErrorLabel
                    >
                        <select
                            className="form-control"
                            name="country_id"
                            value={accountingAreaCountryId}
                            disabled
                            required
                        >
                            {_.map(countries, (country) => (
                                <option key={country.id} value={country.id}>
                                    {getCountryName(country)}
                                </option>
                            ))}
                        </select>
                    </ValidatorFormGroup>
                    {this.renderPropagateHtmlCheckbox()}
                </div>
            );
        } else {
            return <div />;
        }
    },
});

export default connectR(
    (store) => ({
        countries: store.countriesDetails.idToCountry,
        selectedPartner: store.partnerManager.selectedPartner,
    }),
    {}
)(translate('ObjectAddressForm')(ObjectAddressForm));
